var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronrightpurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56365 13.2364C6.21218 12.8849 6.21218 12.3151 6.56365 11.9636L9.52726 9L6.56365 6.0364C6.21218 5.68492 6.21218 5.11508 6.56365 4.7636C6.91512 4.41213 7.48497 4.41213 7.83645 4.7636L11.4364 8.3636C11.7879 8.71508 11.7879 9.28492 11.4364 9.6364L7.83645 13.2364C7.48497 13.5879 6.91513 13.5879 6.56365 13.2364Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronrightpurple);
export default __webpack_public_path__ + "static/media/chevron.right.purple.2710cbcc56043dc16759c8e2eec9fd13.svg";
export { ForwardRef as ReactComponent };